// Energy breakdown tree
// tanstack
import { createFileRoute } from '@tanstack/react-router';

// feature-components
import TreePage from '@/features/energyxplorer/components/deepdive/TreePage';

export const Route = createFileRoute(
  '/$accountId/_user/energyxplorer/deepdive/$energyGroupId/energy-breakdown',
)({
  component: TreePage,
  staticData: { crumb: 'energyxplorer:app_bar.energy_tree' },
});
